import { AUDIO, useAudio } from '@/app/providers/AudioProvider';
import { useDeviceInfo } from '@/hooks/useIsMobile';
import { useTranslation } from '@/hooks/useTranslation';
import { getTeamColorHex } from '@/lib/config/teams';
import React from 'react'

const LobbyPanel = ({
    name,
    color,
    className,
    disabled = false,
    onJoin,
    onEditTeam,
    children
}: {
    name?: string;
    color?: string;
    className?: string;
    disabled?: boolean;
    onJoin?: () => void;
    onEditTeam?: () => void;
    children: React.ReactNode
}) => {
    const { isMobile } = useDeviceInfo();
    const { play } = useAudio();
    const { t } = useTranslation();
    return (
        <div className={`text-white ${name ? 'pt-3 xl:pt-6' : 'pt-2'} pb-2 px-4 xl:px-8 w-fit h-fit relative ${className || ''} ${disabled ? 'opacity-90' : ''}`}>
            {!isMobile && (
                <div className="absolute z-10 top-0 w-full h-full left-0 blur-sm flex">
                    <div className="px-10 w-1/2 h-full bg-gradient-to-r from-transparent via-50% via-black/70 to-black/70"></div>
                    <div className="px-10 w-1/2 h-full bg-gradient-to-r from-black/70 via-50% via-black/70 to-transparent"></div>
                </div>
            )}
            <div className="flex">
                {name && (
                    <div className="z-20 absolute -top-4 md:-top-2 left-3 text-[20px] xl:text-[28px] font-semibold font-orgon-plan uppercase whitespace-nowrap flex gap-2 items-center ">
                        {color && (
                            <div
                                className="w-[18px] h-[18px] rounded border border-yellow-300 shadow-[inset_0_0_6px_#000]"
                                style={{ backgroundColor: getTeamColorHex(color) }}
                            ></div>
                        )}
                        <span
                            className={`${disabled ? 'grayscale' : ''} text-shadow shadow-yellow-800 max-w-[220px] md:max-w-[300px] truncate`}
                            style={{ transform: 'rotateX(60deg)' }}
                        >
                            {name}
                        </span>
                        {onEditTeam && (
                            <div
                                onMouseEnter={() => {play(AUDIO.HOVER)}}
                                onClick={() => { play(AUDIO.CLICK); onEditTeam(); }}
                                className="text-black bg-[#FFFBD4] shadow-[0_0_5px_2px_rgb(133_77_14)] rounded-lg text-xs px-2 cursor-pointer ml-1 font-eurostar-black"
                            >
                                <span>{t("lobby.editParty")}</span>
                            </div>
                        )}
                        {onJoin && (
                            <div
                                onMouseEnter={() => {play(AUDIO.HOVER)}}
                                onClick={() => { play(AUDIO.CLICK); onJoin(); }}
                                className="text-black bg-[#FFFBD4] shadow-[0_0_5px_2px_rgb(133_77_14)] rounded-lg text-xs px-2 cursor-pointer ml-1 font-eurostar-black"
                            >
                                <span>{t("lobby.joinParty")}</span>
                            </div>
                        )}
                    </div>
                )}
                <div className={`z-20 w-full mt-1 ${disabled ? 'grayscale' : ''}`}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default LobbyPanel